import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, createStaticVNode as _createStaticVNode } from "vue"
import _imports_0 from '@/assets/selections-logo.png'


const _hoisted_1 = { class: "container-fluid" }
const _hoisted_2 = { class: "row" }
const _hoisted_3 = { class: "col-10 offset-1 col-md-6 offset-md-3 h100" }
const _hoisted_4 = { class: "d-flex justify-content-center align-items-start h-50" }
const _hoisted_5 = {
  class: "text-center mt-5",
  style: {"font-size":"1.5rem"}
}
const _hoisted_6 = { key: 0 }
const _hoisted_7 = { key: 1 }
const _hoisted_8 = { key: 2 }

import { ref } from 'vue';
import { useFirestore } from 'vuefire';
import { query } from 'firebase/database';
import { collection, where, getDocs } from 'firebase/firestore';
import { DateTime } from 'luxon';
import { auth } from '@/firebase';
import { signInWithEmailAndPassword, onAuthStateChanged } from 'firebase/auth';
import { PlayerCreds } from '@/secrets';
import { WordSet } from '@/models/WordSet';
import router from '@/router';



export default /*@__PURE__*/_defineComponent({
  __name: 'MenuView',
  setup(__props) {

const gamePrepared = ref(false);
const errorPreparingPuzzle = ref(false);
const db = useFirestore();
const preparePuzzle = async () => {
  try {
    let rws = localStorage.getItem('wordSet');
    let ws = rws ? new WordSet(JSON.parse(rws)) : null;
    let puzzleDate = DateTime.utc().setZone('America/Denver').toFormat('yyyy-MM-dd');
    if (ws) {
        if (ws.date != puzzleDate) {
            ws = null;
        } else {
            gamePrepared.value = true;
        }
    }
    if (!ws) {
        //@ts-ignore
        const q = query(collection(db, 'wordSets'), where('isToday', '==', true));
        //@ts-ignore
        const querySnapshot = await getDocs(q);
        if (!querySnapshot.empty) {
            const doc = querySnapshot.docs[0];  // Only one puzzle per day
            ws = new WordSet(doc.data());
            localStorage.setItem('wordSet', JSON.stringify(ws));
            gamePrepared.value = true;
        } else {
            console.error('No puzzle found for ' + puzzleDate);
            errorPreparingPuzzle.value = true;
        }
    }
  } catch (error) {
    console.error('Error preparing puzzle:', error);
    errorPreparingPuzzle.value = true;
  }
};

onAuthStateChanged(auth, (currentUser) => {
    if (!currentUser) {
        signInWithEmailAndPassword(auth, PlayerCreds.email, PlayerCreds.password)
            .catch(error => {
                console.error('Error signing in:', error);
                errorPreparingPuzzle.value = true;
            });
    } else {
        preparePuzzle();
    }
});

const getPuzzleNumber = () => {
  let now = DateTime.utc().setZone('America/Denver');
  return Math.floor(now.diff(DateTime.fromISO('2024-10-11'), 'days').days) + 1;
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _cache[3] || (_cache[3] = _createStaticVNode("<div class=\"d-flex justify-content-center align-items-end h-50\"><div class=\"text-center\"><img src=\"" + _imports_0 + "\" alt=\"\" width=\"100px\"><h1 class=\"card-title mt-5\" style=\"font-size:3rem;\">Selections</h1><h3 class=\"card-text\">Pick the word with stronger connections</h3></div></div>", 1)),
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            (gamePrepared.value)
              ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                  _createElementVNode("div", {
                    class: "mb-2 btn btn-outline-light btn-lg",
                    style: {"font-size":"1.5rem"},
                    onClick: _cache[0] || (_cache[0] = ($event: any) => (_unref(router).push({ name: 'game' })))
                  }, "Play"),
                  _createElementVNode("div", null, "Puzzle No. " + _toDisplayString(getPuzzleNumber()), 1)
                ]))
              : (errorPreparingPuzzle.value)
                ? (_openBlock(), _createElementBlock("div", _hoisted_7, _cache[1] || (_cache[1] = [
                    _createElementVNode("div", { class: "alert alert-info" }, [
                      _createTextVNode("Oh no, something went wrong 🙀 "),
                      _createElementVNode("br"),
                      _createElementVNode("br"),
                      _createTextVNode(" We're looking into it! "),
                      _createElementVNode("br"),
                      _createTextVNode(" In the meantime, try refreshing soon.")
                    ], -1)
                  ])))
                : (_openBlock(), _createElementBlock("div", _hoisted_8, _cache[2] || (_cache[2] = [
                    _createElementVNode("div", {
                      class: "spinner-border text-light m-4",
                      role: "status"
                    }, [
                      _createElementVNode("span", { class: "visually-hidden" }, "Loading...")
                    ], -1)
                  ])))
          ])
        ])
      ])
    ])
  ]))
}
}

})